import React from 'react';

import classnames from 'classnames';

import s from './BaseInfoMessage.module.scss';
import { TBaseInfoMessageProps } from './BaseInfoMessage.types';

export const BaseInfoMessage: React.FC<TBaseInfoMessageProps> = ({
  className,
  width,
  children,
}) => {
  if (!children) return null;

  return (
    <div
      className={classnames(s.container, className)}
      style={{ ['--width' as string]: width }}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
};
